import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

type HrReportPayload = {
  date?: string;
  employeeCodes?: string[];
};

export const HrReportService = {
  getSummary: (date?: string) => {
    const url = REQUEST_URL.HR_DAILY_REPORT_SUMMARY;
    return RequestUtil.get({
      url,
      query: date ? { date } : {},
    });
  },

  preview: (payload?: HrReportPayload) => {
    const url = REQUEST_URL.HR_DAILY_REPORT_PREVIEW;
    return RequestUtil.post({
      url,
      data: payload || {},
    });
  },

  send: (payload?: HrReportPayload) => {
    const url = REQUEST_URL.HR_DAILY_REPORT_SEND;
    return RequestUtil.post({
      url,
      data: payload || {},
    });
  },

  getLogs: (params?: { date?: string; page?: number; limit?: number }) => {
    const url = REQUEST_URL.HR_DAILY_REPORT_LOGS;
    return RequestUtil.get({
      url,
      query: params || {},
    });
  },
};
